export default "__VITE_ASSET__15dfcf80__"